// SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
// SPDX-License-Identifier: Apache-2.0

import { html, LitElement } from 'lit';
import { audit, useStyles } from '@nvidia-elements/core/internal';
import styles from './drawer-header.css?inline';

/**
 * @element nve-drawer-header
 * @description Displays the title and optional close control at the top of a drawer to identify its purpose.
 * @documentation https://nvidia.github.io/elements/docs/elements/drawer/
 * @since 0.16.0
 * @entrypoint \@nvidia-elements/core/drawer
 * @slot - default slot for the drawer header
 * @cssprop --border-bottom
 * @cssprop --min-height
 * @cssprop --padding
 * @aria https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/
 */
@audit()
export class DrawerHeader extends LitElement {
  static styles = useStyles([styles]);

  static readonly metadata = {
    tag: 'nve-drawer-header',
    version: '0.0.0',
    parents: ['nve-drawer']
  };

  render() {
    return html`
      <div internal-host>
        <slot></slot>
      </div>
    `;
  }

  connectedCallback() {
    super.connectedCallback();
    this.slot = 'header';
  }
}
